import { Progress } from "antd";
import { SpaceVertical } from "../../../common/utils/spacing";
import "./competences.css";

export const CompetencesMobile = () => {
  return (
    <div className="m-competences m-page">
      <h1 className="title">CONNAISSANCE</h1>
      <p className="sub-title">MON NIVEAU DE CONNAISSANCES</p>

      <SpaceVertical size={40} />

      <div className="m-competences-content">
        <OneProgress name="HTML & CSS" level={80} />
        <SpaceVertical size={35} />

        <OneProgress name="JAVASCRIPT" level={70} />
        <SpaceVertical size={35} />

        <OneProgress name="REACT JS" level={70} />
        <SpaceVertical size={35} />

        <OneProgress name="REACT NATIVE" level={60} />
        <SpaceVertical size={35} />

        <OneProgress name="FIGMA" level={80} />
        <SpaceVertical size={35} />

        <OneProgress name="PHOTOSHOP" level={80} />
        <SpaceVertical size={35} />

        <OneProgress name="ILLUSTRATOR" level={70} />
      </div>
    </div>
  );
};

const OneProgress = ({ name, level }) => {
  return (
    <div className="m-one-progress-com">
      <h3>{name}</h3>
      <Progress type="line" strokeWidth={12} percent={level} />
    </div>
  );
};
